<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Configuration Management</h2>
          </div>
          <div class="body pt-0">
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- Share and Save Coupon Listing -->
            <b-table
              responsive
              table-class="mb-0 table-custom border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(value)="data">
                <div v-if="data.item.edit">
                  <div
                    v-if="data.item.date"
                    class="form-group datepicker m-0 column-2-half"
                  >
                    <b-input-group class="flex-nowrap">
                      <div class="input-group-prepend">
                        <span class="input-group-text">From</span>
                        <span
                          class="input-group-text"
                          @click="$refs.birthdate1.showCalendar()"
                        >
                          <i class="icon-calendar"></i>
                        </span>
                      </div>
                      <datepicker
                        class="form-control"
                        ref="birthdate1"
                        v-model="data.item.value"
                        placeholder=""
                        :typeable="false"
                      ></datepicker>
                    </b-input-group>
                  </div>
                  <div
                    class="form-group m-0"
                    v-else-if="data.item.phone"
                    :class="{
                      errors: mobileInputError == false,
                      success: data.item.value && mobileInputError,
                    }"
                  >
                    <div class="float-label">
                      <vue-tel-input
                        v-model="data.item.value"
                        v-bind="primaryMobileNumber"
                        @validate="mobileInputValidate"
                        ref="telInput"
                        @keydown.native="restrictSpecialCharacter($event)"
                      >
                        <template v-slot:arrow-icon>
                          <span class="vti__dropdown-arrow">{{ "▼" }}</span>
                        </template>
                      </vue-tel-input>
                      <div class="line"></div>
                      <i
                        class="fa fa-times"
                        v-if="mobileInputError == false"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="mobileInputError && data.item.value"
                      ></i>
                    </div>
                  </div>
                  <div
                    v-else-if="data.item.switch"
                    class="custom-switch success-error-bg"
                  >
                    <input
                      type="checkbox"
                      class="custom-switch-input"
                      :id="`customSwitchemail${data.index}`"
                      v-model="data.item.value"
                    />
                    <label
                      class="custom-switch-label pr-4 pl-5"
                      :for="`customSwitchemail${data.index}`"
                    >
                      <span class="custom-switch-text1">Active</span>
                      <span class="custom-switch-text2">InActive</span>
                    </label>
                  </div>
                  <span v-else-if="data.item.number">
                    <input
                      type="text"
                      class="form-control"
                      v-model="data.item.value"
                      @keypress="onlyNumber($event)"
                    />
                  </span>
                  <input
                    v-else
                    type="text"
                    class="form-control"
                    v-model="data.item.value"
                  />
                </div>
                <div v-else>
                  <span v-if="data.item.switch">
                    {{ data.value ? "Active" : "Inactive" }}
                  </span>
                  <span v-else-if="data.item.date">
                    {{ moment(data.value).format("YYYY-MM-DD") }}
                  </span>
                  <span v-else>{{ data.value ? data.value : "--" }}</span>
                </div>
              </template>
              <template #cell(action)="data">
                <i
                  v-if="data.item.edit"
                  class="fa fa-check text-success fa-lg cursor-pointer mr-1"
                  @click="data.item.edit = !data.item.edit"
                ></i>
                <i
                  v-if="data.item.edit"
                  class="fa fa-times text-danger fa-lg cursor-pointer"
                  @click="data.item.edit = !data.item.edit"
                ></i>
                <i
                  v-else
                  class="fa fa-edit text-info fa-lg cursor-pointer"
                  @click="data.item.edit = !data.item.edit"
                ></i>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const moment = require("moment");
const { VueTelInput } = require("vue-tel-input");
export default {
  name: "ConfigurationManagement",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    Datepicker: () => import("vuejs-datepicker"),
    VueTelInput,
  },
  data() {
    return {
      moment,
      items: [
        {
          configuration: "Store Phone Number",
          value: "7908061086",
          edit: false,
          phone: true,
        },
        {
          configuration: "To Date For Free First Transfer",
          value: "2024-10-12",
          date: true,
          edit: false,
        },
        {
          configuration: "To Date For Free First Transfer",
          value: "2024-10-12",
          date: true,
          edit: false,
        },
        {
          configuration: "Site Timer period (Seconds)",
          value: 150000,
          number: true,
          edit: false,
        },
        {
          configuration: "First Free Transfer ON/OFF",
          value: true,
          switch: true,
          edit: false,
        },
        {
          configuration: "Referee Earning",
          value: 10,
          number: true,
          edit: false,
        },
        {
          configuration: "Instant Bank Deposit Charge",
          value: 0,
          number: true,
          edit: false,
        },
        {
          configuration: "USSD Autopay Enable/Disable",
          value: false,
          switch: true,
          edit: false,
        },
      ],
      mobileInputError: "",
      primaryMobileNumber: {
        mode: "auto",
        defaultCountry: "gb",
        autoFormat: false,
        dropdownOptions: {
          showFlags: true,
          disabled: false,
          showDialCodeInSelection: false,
        },
      },

      fields: [
        {
          key: "configuration",
          label: "Configuration",
          sortable: true,
          thClass: "th_sortfix",
        },
        { key: "value", label: "Value", sortable: true, thClass: "th_sortfix" },
        {
          key: "action",
          label: "Action",
          thClass: "th_sortfix text-right pr-3",
          tdClass: "text-right pr-4",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],
      date: "",

      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 50,
      pageOptions: [50, 100, 150, { value: 1000, text: 1000 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  methods: {
    updateConfigration(data) {
      console.log(data.item);
    },
    mobileInputValidate(phoneObject) {
      this.mobileInputError = phoneObject.valid;
    },
    restrictSpecialCharacter(event) {
      let keyCode = event.keyCode ? event.keyCode : event.which;
      if (
        keyCode === 8 ||
        keyCode === 9 ||
        keyCode === 13 ||
        keyCode === 46 ||
        (keyCode >= 37 && keyCode <= 40)
      ) {
        return; // Allow these keys
      }
      if (keyCode >= 96 && keyCode <= 105) {
        return; // Allow number input from the numpad
      }
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    onlyNumber(event) {
      let keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
      if (/^\W$/.test(event.key)) {
        event.preventDefault();
      }
    },
    changeClass() {
      const temp = document.getElementsByClassName("vdp-datepicker__calendar");
      const table = document.getElementsByClassName("table-responsive");
      if (table.length) {
        if (temp.length > 0 && !temp[0].style.cssText) {
          table[0].classList = "table-responsive overflow-visible";
        } else {
          table[0].classList = "table-responsive";
        }
      }
    },
    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },
  },
  mounted() {
    this.totalRows = this.items.length;
    window.addEventListener("click", this.changeClass);
  },
  destroyed() {
    window.removeEventListener("click", this.changeClass);
  },
};
</script>
